import React, { useEffect, useState } from "react";
import { Amplify, API, graphqlOperation } from "aws-amplify";
import { listBanners } from "../../graphql/queries";
import { Container, Row, Col } from "reactstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "../../styles/hero-slider.css";


const bannerLinks = [{}];

const HeroSlider = () => {

  const [bannerList, setListBanner] = useState(bannerLinks);


  useEffect(() => {
    fetchTodos();
  }, []);
  const fetchTodos = async () => {
    try {
      const listBannerData = await API.graphql(graphqlOperation(listBanners));

      const _bannerList = listBannerData?.data?.listBanners?.items;
      setListBanner(_bannerList);
    } catch (err) {
      console.log(err, "error fetching listMenu");
    }
  };

  const settings = {
    fade: true,
    speed: 2000,
    autoplaySpeed: 3000,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
  };

  console.log(bannerList, "bannerList")


  return (
    <header className="hero__slider-banner">
      {/* header top */}
      <div className="">
        <Slider {...settings} className="slider__item">
          {bannerList.map((bannerList, index) => (
            <div key={index}>
              <LazyLoadImage src={bannerList.image} width="100%" />
            </div>
          ))}
        </Slider>
      </div>
    </header>
  );
};

export default HeroSlider;
